<template>
  <div
    class="sidebar"
    :data-color="backgroundColor"
    :data-active-color="activeColor"
  >
    <div class="logo">
      <a
        class="simple-text logo-mini"
        aria-label="sidebar mini logo"
        :href="publicPath"
      >
        <div class="logo-img">
          <img :src="logo" alt />
        </div>
      </a>
      <a class="simple-text logo-normal" :href="publicPath">{{ title }}</a>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <!-- <slot></slot> -->
      <ul class="nav" v-if="profileData !== null">
        <slot name="links">
          <sidebar-item
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :link="link"
          >
            <sidebar-item
              v-for="(subLink, index) in link.children"
              :key="subLink.name + index"
              :link="subLink"
            ></sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import { mapGetters } from "vuex";
import axios from "axios";
import store from "@/store/index.js";
import _ from "underscore";
import {
  userLoadApi,
  fbGraphCreateProfile,
  fbGraphInstagramCheck,
  userRelatedProfilesApi,
  clientStoreCheckApi,
} from "@/config/appSettings";

import "perfect-scrollbar/dist/css/perfect-scrollbar.css";
export default {
  data() {
    return {
      isLoggedIn: false,
      currentUser: false,
      auth: null,
      open: false,
      isTeam: false,
      isInfluencer: false,
      isClient: false,
      profileData: null,
      sidebarLinks: [],
      relatedProfileList: null,
      publicPath: process.env.BASE_URL,
      activeInstagramId: null,
      activeInstagramProfile: null,
      activeClientId: null,
      storeExists: false,
      storeName: null,
    };
  },
  props: {
    title: {
      type: String,
      default: "HelloConvo",
      description: "Client Dashboard",
    },
    backgroundColor: {
      type: String,
      default: "white",
      validator: (value) => {
        let acceptedValues = ["white", "brown", "black"];
        return acceptedValues.indexOf(value) !== -1;
      },
      description: "Sidebar background color (white|brown|black)",
    },
    activeColor: {
      type: String,
      default: "success",
      validator: (value) => {
        let acceptedValues = [
          "primary",
          "info",
          "success",
          "warning",
          "danger",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
      description:
        "Sidebar active text color (primary|info|success|warning|danger)",
    },
    logo: {
      type: String,
      default:
        process.env.BASE_URL + "static/img/helloconvo_logo_transparent.png",
      description: "HelloConvo Logo",
    },
    /*sidebarLinks: {
        type: Array,
        default: () => [],
        description: 'Sidebar links. Can be also provided as children components (sidebar-item)'
      },*/
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  methods: {
    async initScrollBarAsync() {
      let isWindows = navigator.platform.startsWith("Win");
      if (!isWindows) {
        return;
      }
      //const PerfectScroll = await import("perfect-scrollbar");
      //PerfectScroll.initialize(this.$refs.sidebarScrollArea);
    },
    logout: function () {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.go({
            path: this.$router.path,
          });
        });
    },
    async setProfileType() {
      //console.log("LOADING PROFILE FROM NAV:", this.profileStore);
      if (this.profileStore !== false) {
        this.profileData = this.profileStore;
        if (this.profileStore.isTeam === true) {
          this.isTeam = true;
        }
        try {
          if (this.profileStore.isInfluencer === true) {
            this.isInfluencer = true;
          }
          if (this.profileStore.isClient === true) {
            this.isClient = true;
            console.log("PROFILEDATA:", this.profileData);
            if (
              typeof this.profileData.relatedClients[0].clientId !== "undefined"
            ) {
              this.activeClientId = this.profileData.relatedClients[0].clientId;
            }
          }
        } catch (err) {
          //console.log("ERROR:", err);
        }
        //console.log("LOADING BUILD MENU...");
        if (this.sidebarLinks.length < 1) {
          await this.buildMenu();
        }
        return;
      }
      // IF NOT LOADED YET LOAD DIRECTLY TO SET PROFILE TYPE
      //console.log("PROFILE STORE MAIN:", this.profileStore);
      if (this.profileStore === false) {
        let profileLoadResponse = await axios.get(`${userLoadApi}${this.auth}`);
        //console.log("PROFILE DATA MAIN FROM NAV:", profileLoadResponse.data);
        if (profileLoadResponse.data.success === true) {
          this.profileData = profileLoadResponse.data.result;
          store.dispatch("updateProfile", profileLoadResponse.data.result);

          if (profileLoadResponse.data.result.isTeam === true) {
            this.isTeam = true;
            await this.buildMenu();
            return;
          }
          try {
            if (profileLoadResponse.data.result.profileTypes.length > 0) {
              if (
                profileLoadResponse.data.result.profileTypes.indexOf(
                  "influencer"
                ) !== -1
              ) {
                this.isInfluencer = true;
                //console.log("PROFILE TYPE: INFLUENCER");
              }
              if (
                profileLoadResponse.data.result.profileTypes.indexOf(
                  "client"
                ) !== -1
              ) {
                this.isClient = true;

                if (
                  typeof this.profileData.relatedClients[0].clientId !==
                  "undefined"
                ) {
                  this.activeClientId = this.profileData.relatedClients[0].clientId;
                }
              }
              /*if (this.sidebarLinks.length < 1) {
                await this.buildMenu();
              }*/

              return;
            }
          } catch (err) {
            //console.log("ERROR:", err);
          }
        } else {
          return;
          //console.log("PROFILE LOAD FAILED");
        }
        //console.log("HERE IS THE PROFILE DATA:", this.profileData)
      }
      //console.log("HERE IS THE PROFILE DATA:", this.profileData);

      //console.log("HERE IS THE PROFILE DATA:", this.profileData)
    },
    async insertAt(array, index, ...elementsArray) {
      array.splice(index, 0, ...elements);
    },
    async buildMenu() {
      try {
        //console.log("USER MENU FROM STORE:", this.userMenu);
        //console.log("RELATED PROFILE STORE:", this.relatedProfiles);
        if (this.userMenu.length > 0) {
          this.sidebarLinks = this.userMenu;
          return;
        }
        if (this.isTeam === true) {
          this.sidebarLinks = [
            {
              name: "Content",
              icon: "fab fa-instagram",
              children: [
                {
                  name: "Search Hashtags",
                  path: "/instagram/search/hashtags",
                },
                {
                  name: "Search Content",
                  path: "/instagram/search/content",
                },
              ],
            },
            {
              name: "Influencers",
              icon: "fa fa-grin-stars",
              children: [
                {
                  name: "Campaigns",
                  path: "/influencer-campaign/list",
                },
                {
                  name: "Search",
                  path: "/instagram/search",
                },
              ],
            },
            {
              name: "Clients",
              icon: "fa fa-street-view",
              path: "/client/list",
            },
            {
              name: "Sales",
              icon: "fas fa-comment-dollar",
              children: [
                {
                  name: "Ad Search",
                  path: "/sales/ad-search",
                },
              ],
            },
            {
              name: "My Profile",
              icon: "fa fa-user-circle",
              path: "/profile/update",
            },
          ];
        }
        if (this.isClient === true) {
          //console.log("IS CLIENT:", this.isClient);
          //console.log("PROFILE STORE:", this.profileStore);
          this.sidebarLinks = [
            {
              name: "Dashboard",
              icon: "fa fa-tachometer-alt",
              path: `/dashboard/client/${this.profileData.relatedClients[0].clientId}`,
            },
            {
              name: "Influencers",
              icon: "fa fa-grin-stars",
              path: `/client/influencer-campaigns/${this.profileData.relatedClients[0].clientId}`,
            },

            {
              name: "My Profile",
              icon: "fa fa-user-circle",
              path: "/profile/update",
            },
            {
              name: "Account Settings",
              icon: "fa fa-cog",
              children: [
                {
                  name: "Business Details",
                  path: `/client/detail/${this.profileData.relatedClients[0].clientId}`,
                },
                {
                  name: "Instagram Profiles",
                  path: "/account/active-instagram",
                },
                {
                  name: "Shopify Stores",
                  path: `/account/active-shopify/${this.profileData.relatedClients[0].clientId}`,
                }
              ],
            },
          ];
          if (this.storeExists == true) {
            await this.sidebarLinks.splice(2, 0, {
              name: "Shopify",
              icon: "fab fa-shopify",
              children: [
                {
                  name: "Sales",
                  path: "/shopify/orders/" + this.storeName,
                },
                {
                  name: "Discounts",
                  path: "/shopify/discounts/" + this.storeName,
                },
              ],
            });
          }
          if (this.relatedProfiles.length > 0) {
            let igMenuLocation = 2;
            let shopifyMenuCheck = this.sidebarLinks.filter((x) => {
              return x.name == "Shopify";
            });
            if (shopifyMenuCheck.length > 0) {
              igMenuLocation = 3;
            }
            await this.sidebarLinks.splice(igMenuLocation, 0, {
              name: "Instagram",
              icon: "fab fa-instagram",
              children: [
                {
                  name: "Analytics",
                  path:
                    "/instagram/analytics/all/" +
                    this.relatedProfiles[0].instagramProfile,
                },
                {
                  name: "Posts",
                  path:
                    "/instagram/content/" +
                    this.relatedProfiles[0].instagramProfile,
                },
              ],
            });
          }
          if (this.profileStore.features.length > 0) {
            let dynamicMenuPos = [];
            let shopifyMenuCheck = this.sidebarLinks.filter((x) => {
              return x.name == "Shopify";
            });
            if (shopifyMenuCheck.length > 0) {
              dynamicMenuPos.push("shopify");
            }
            let igMenuCheck = this.sidebarLinks.filter((x) => {
              return x.name == "Instagram";
            });
            if (igMenuCheck.length > 0) {
              dynamicMenuPos.push("instagram");
            }

            let addLocation = 4;

            //console.log("DYNAMIC MENU POSITION",dynamicMenuPos)

            if (dynamicMenuPos.length == 2) {
              addLocation = 4;
            }
            if (dynamicMenuPos.length == 1) {
              addLocation = 3;
            }
            if (dynamicMenuPos.length == 0) {
              addLocation = 2;
            }

            let toolLinkArray = this.profileStore.features.map((x) => {
              if (x === "hashtag-search") {
                return {
                  name: "Hashtag Search",
                  path: `/instagram/search/hashtags`,
                };
              }
              if (x === "content-search") {
                return {
                  name: "Content Search",
                  path: `/instagram/search/content`,
                };
              }
              if (x === "tracking-links") {
                return {
                  name: "Link Tracking",
                  path: `/tools/tracking-links/client/${this.profileData.relatedClients[0].clientId}`,
                };
              }

              return [];
            });
            toolLinkArray = _.flatten(toolLinkArray);
            if (toolLinkArray.length > 0) {
              this.sidebarLinks.splice(addLocation, 0, {
                name: "Tools ",
                icon: "fas fa-tools",
                children: toolLinkArray,
              });
            }
          }
        }
        if (this.isInfluencer === true) {
          if (this.profileStore != false) {
            if (this.profileStore.relatedInfluencers.length === 1) {
              this.activeInstagramId = this.profileStore.relatedInfluencers[0].instagramId;

              this.activeInstagramProfile = this.profileStore.relatedInfluencers[0].instagramProfile;
              //console.log("ACTIVE INSTAGRAM:", this.activeInstagramProfile)
            }
          }

          this.sidebarLinks = [
            {
              name: "Collaborations",
              icon: "fa fa-grin-stars",
              path: `/influencer/collaborations/${this.activeInstagramId}`,
            },
            {
              name: "Earnings",
              icon: "fa fa-money",
              path: "/influencer/earnings",
            },
            {
              name: "Account Settings",
              icon: "fa fa-cog",
              children: [
                {
                  name: "My Profile",
                  path: "/profile/update",
                },
                {
                  name: "Instagram Profiles",
                  path: "/account/active-instagram",
                },
              ],
            },
          ];
          if (this.relatedProfiles.length > 0) {
            this.sidebarLinks.splice(1, 0, {
              name: "Instagram ",
              icon: "fab fa-instagram",
              children: [
                {
                  name: "Analytics",
                  path:
                    "/instagram/analytics/all/" +
                    this.relatedProfiles[0].instagramProfile,
                },
                {
                  name: "Posts",
                  path:
                    "/instagram/content/" +
                    this.relatedProfiles[0].instagramProfile,
                },
              ],
            });
          }
          if (this.profileStore.features.length > 0) {
            let addLocation = 2;
            if (this.relatedProfiles.length < 1) {
              let addLocation = 1;
            }
            //console.log("CREATE FEATURE LINKS");
            let toolLinkArray = this.profileStore.features.map((x) => {
              if (x === "hashtag-search") {
                return {
                  name: "Hashtag Search",
                  path: `/instagram/search/hashtags`,
                };
              }
              if (x === "content-search") {
                return {
                  name: "Content Search",
                  path: `/instagram/search/content`,
                };
              }
              if (x === "tracking-links") {
                return {
                  name: "Link Tracking",
                  path: `/tools/tracking-links/influencer/${this.profileStore.relatedInfluencers[0].influencerId}`,
                };
              }

              return [];
            });
            toolLinkArray = _.flatten(toolLinkArray);
            if (toolLinkArray.length > 0) {
              this.sidebarLinks.splice(addLocation, 0, {
                name: "Tools ",
                icon: "fas fa-tools",
                children: toolLinkArray,
              });
            }
          }
        }
        if (this.sidebarLinks.length > 0) {
          //console.log("UPDATING MENU...");
          store.dispatch("storeMenu", this.sidebarLinks);
        }
      } catch (err) {
        console.log("MENU LOAD ERROR:", err);
      }
    },
    async checkNoAuthProfiles() {
      try {
        // console.log("CHECKING RELATED PROFILES: ", this.relatedProfiles);
        if (this.relatedProfileStore !== null) {
          this.relatedProfiles = this.relatedProfileStore;
        }
        if (this.relatedProfiles !== null) {
          this.relatedProfileList = this.relatedProfiles.map((x) => {
            return x.instagramProfile;
          });
          let instagramProfileString = this.relatedProfileList.join(",");
          /*console.log(
            "LINK:",
            `${fbGraphInstagramCheck}/?usertoken=${this.auth}&profiles=${instagramProfileString}`
          );*/
          let noAuthProfileCheckResponse = await axios.get(
            `${fbGraphInstagramCheck}/?usertoken=${this.auth}&profiles=${instagramProfileString}`
          );
          /*console.log(
            "RELATED PROFILE AUTH CHECK:",
            noAuthProfileCheckResponse.data
          );*/
          if (noAuthProfileCheckResponse.data.exists === false) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.noAuthProfiles = this.relatedProfiles;
            this.instagramLinked = false;
          }
          if (noAuthProfileCheckResponse.data.exists == true) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.instagramLinked = true;
          }
        } else {
          //console.log("RELATED PROFILES NOT FOUND");
          if (this.isTeam !== true) {
            if (this.relatedProfileStore == null) {
              let relatedProfileResponse = await axios.get(
                `${userRelatedProfilesApi}/?usertoken=${this.auth}`
              );
              this.relatedProfiles = relatedProfileResponse.data.result;
              store.dispatch(
                "storeRelatedProfiles",
                relatedProfileResponse.data.result
              );
            } else {
              this.relatedProfiles = this.relatedProfileStore;
            }
            //console.log("RELATED PROFILE SECOND CHECK: ", this.relatedProfiles);
          }
        }
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },

    async clientStoreCheck() {
      try {
        let clientCheckUrl = `${clientStoreCheckApi}/?usertoken=${this.auth}&client=${this.activeClientId}`;
        //console.log("CLIENT CHECK URL:", clientCheckUrl);
        let clientStoreCheckResponse = await axios.get(clientCheckUrl);

        if (clientStoreCheckResponse.data.success == true) {
          //console.log("CLIENT STORE RESULTS:", clientStoreCheckResponse.data);
          this.storeExists = true;
          this.storeName = clientStoreCheckResponse.data.result;
          //console.log("HERES THE STORE NAME:", this.storeName);
        }
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadPageData() {
      this.initScrollBarAsync();
      try {
        if (typeof firebase.auth().currentUser.uid !== "undefined") {
          this.auth = firebase.auth().currentUser.uid;
          await this.setProfileType();
          if (this.relatedProfileStore == null) {
            await this.getRelatedProfiles();
          }
          if (this.pendingAuthProfiles == null) {
            await this.checkNoAuthProfiles();
          }

          //console.log("ACTIVE CLIENT:", this.activeClientId);

          if (
            this.activeClientId !== null &&
            this.activeClientId !== "undefined"
          ) {
            await this.clientStoreCheck();
          }

          await this.buildMenu();
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async getRelatedProfiles() {
      //console.log("RELATED PROFILES:", this.relatedProfileStore);

      if (this.isTeam !== true) {
        if (
          this.relatedProfileStore == null ||
          typeof this.relatedProfileStore == "undefined"
        ) {
          let relatedProfileUrl = `${userRelatedProfilesApi}/?usertoken=${this.auth}`;
          //console.log("RELATED PROFILE URL:", relatedProfileUrl);
          let relatedProfileResponse = await axios.get(relatedProfileUrl);
          this.relatedProfiles = relatedProfileResponse.data.result;
          store.dispatch(
            "storeRelatedProfiles",
            relatedProfileResponse.data.result
          );
        } else {
          this.relatedProfiles = this.relatedProfileStore;
        }
        //console.log("RELATED PROFILE SECOND CHECK: ", this.relatedProfiles);
      }
    },
  },

  mounted() {
    this.loadPageData();
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
  created() {
    if (firebase.auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = firebase.auth().currentUser.email;
    }
  },
  computed: {
    ...mapGetters([
      "profileStore",
      "userMenu",
      "relatedProfileStore",
      "pendingAuthProfiles",
    ]),
  },
};
</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
